import constants from '../constants/app.properties';

/**
 * Infinite scroller which calculates the scrolling and based on the percenatage metioned hits
 * or proceeds to call method.
 * params(event, cb, params, properties)
 *
 * eg:
 *  infiniteScroller(
    event,
    callApi(),
    {
      sortColumn: 'name',
      sortOrder: 'asc',
      offset: 12,
      limit: 10
    },
    {
      percentage: 100,
      currentLength: 125,
      totalLength: 129,
    }
  )
 */
export default function infiniteScroller(event, cb, params, properties) {
  if (properties.currentLength < properties.totalLength) {
    let scrollPercentage;
    const element = event.target;
    if (element === document) {
      const docElement = document.documentElement;
      const docBody = document.body;
      const scrollTop = 'scrollTop';
      const scrollHeight = 'scrollHeight';
      const value =
        (docElement[scrollTop] || docBody[scrollTop]) /
        ((docElement[scrollHeight] || docBody[scrollHeight]) - docElement.clientHeight);
      scrollPercentage = value * 100;
    } else {
      const value = (element.scrollTop + element.clientHeight) / element.scrollHeight;
      scrollPercentage = value * 100;
    }
    if (properties.type && properties.type === constants.SCROLL_TYPE_HISTORY ?
      element.scrollTop === 0 :
      Math.floor(scrollPercentage) === properties.percentage
    ) {
      cb(params);
    }
  }
}
